import { render, staticRenderFns } from "./CreateOrderView.vue?vue&type=template&id=ece34f34&scoped=true"
import script from "./CreateOrderView.vue?vue&type=script&lang=ts"
export * from "./CreateOrderView.vue?vue&type=script&lang=ts"
import style0 from "./CreateOrderView.vue?vue&type=style&index=0&id=ece34f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece34f34",
  null
  
)

export default component.exports